import React, { useContext } from 'react';
import { Input, Slider } from 'antd';
import clsx from 'clsx';
import { SelectValue } from 'antd/lib/select';
import Select from 'src/components/common/Select';
import { Filters, QaErrorsContext } from '../QaErrorsProvider';
import useQaErrorsFiltersFetch from '../hooks/useQaErrorsFiltersFetch';
import styles from './Header.module.less';

const { Search } = Input;
const { Option } = Select;

export const Header: React.FC = () => {
  const { filters, changeFilters, changeScriptHealth } = useContext(QaErrorsContext);
  const { applications, threshold, statuses, errorCodes, siteCodes, scriptNames } = useQaErrorsFiltersFetch();

  const changeHandler =
    <K extends keyof Filters>(key: K) =>
    (value: SelectValue) => {
      changeFilters(key, value as Filters[K]);
    };

  return (
    <div className={styles.header}>
      <div className={styles.headerRow}>
        <div className={styles.field}>
          <Select
            value={filters.siteCode ?? undefined}
            onChange={changeHandler('siteCode')}
            placeholder="Site Code"
            size="large"
            allowClear
            showSearch
          >
            {siteCodes?.map((item) => (
              <Option value={item} key={item}>
                {item}
              </Option>
            ))}
          </Select>
        </div>
        <div className={styles.field}>
          <Select
            value={filters.scriptName ?? undefined}
            onChange={changeHandler('scriptName')}
            placeholder="Script Name"
            size="large"
            allowClear
            showSearch
          >
            {scriptNames?.map((item) => (
              <Option value={item} key={item}>
                {item}
              </Option>
            ))}
          </Select>
        </div>
        <div className={styles.field}>
          <Select
            value={filters.errorCode ?? undefined}
            onChange={changeHandler('errorCode')}
            placeholder="Error Code"
            size="large"
            allowClear
            showSearch
          >
            {errorCodes?.map((item) => (
              <Option value={item} key={item}>
                {item}
              </Option>
            ))}
          </Select>
        </div>
        <div className={styles.field}>
          <Select
            value={filters.applicationId ?? undefined}
            onChange={changeHandler('applicationId')}
            placeholder="Application"
            size="large"
            allowClear
            showSearch
          >
            {applications?.map((item) => (
              <Option value={item.appId} key={item.appId}>
                {item.appName}
              </Option>
            ))}
          </Select>
        </div>
      </div>
      <div className={styles.headerRow}>
        <div className={styles.field}>
          <Select
            value={filters.status ?? undefined}
            onChange={changeHandler('status')}
            placeholder="Script Status"
            size="large"
            allowClear
          >
            {statuses?.map((item) => (
              <Option value={item} key={item}>
                {item}
              </Option>
            ))}
          </Select>
        </div>
        <div className={styles.field}>
          <Select
            value={filters.threshold ?? undefined}
            onChange={changeHandler('threshold')}
            placeholder="Error Threshold"
            size="large"
            allowClear
          >
            <Option value="-1">All</Option>
            {threshold?.map((item) => (
              <Option value={item} key={item}>
                {item}
              </Option>
            ))}
          </Select>
        </div>
        <div className={styles.field}>
          <Search onSearch={changeHandler('priority')} type="number" min={1} placeholder="Script Priority" allowClear />
        </div>
        <div className={clsx(styles.field, styles.slider)}>
          <h5>Script Health</h5>
          <Slider
            defaultValue={[filters?.scriptHealthMin ?? 0, filters?.scriptHealthMax ?? 100]}
            onAfterChange={(val) => changeScriptHealth(val as [number, number])}
            range
            min={0}
            max={100}
            step={1}
            tipFormatter={(val) => `${val}%`}
          />
        </div>
      </div>
    </div>
  );
};
